import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { CommonPaths, SellApartmentFlowPaths } from '../../routes';
import Menu from 'components/menu';
import IconButton from 'components/icon-button';
import Button from 'components/button';
import Header from '../../components/header';
import caretLeft from 'assets/images/caret-left.svg';
import reit from '../../assets/images/itreit_logo.jpg';
import styles from './styles.module.scss';

export type ScreenProps = {
  controls?: React.ReactNode;
};

const ScreenSellMode: React.FC<ScreenProps> = (props) => {
  const { controls } = props;
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(CommonPaths.home);
  };

  return (
    <main className={styles.container}>
      <header className={styles.header}>
        <div>
          <Menu />
          <IconButton icon={caretLeft} onClick={handleBack} />
        </div>
        <h1 className={styles.title}>Мои объекты</h1>
        <div>{controls}</div>
      </header>

      <section
        style={{
          marginBottom: 0,
        }}
        className={clsx(styles.content, styles.contentWithPadding)}
      >
        <div className={styles.containerButton} style={{marginTop: 180}}>
          {/* <img className={styles.house} src={house} width={187} alt='Дом с ключём' /> */}
          <img className={styles.reit} src={reit} width={350} alt='Логотип reit' />
          <Header className={styles.text} text='Сервис умных сделок с недвижимостью' />
        </div>
      </section>

      <footer className={styles.buttons}>
        <Button
          label={'Первичное жилье'}
          onClick={() => navigate(SellApartmentFlowPaths.apartmentSaleAds)}
          variant={'dark'}
        />
        <Button
          label={'Вторичное жилье'}
          onClick={() => navigate(SellApartmentFlowPaths.apartmentSaleAdsSecondary)}
          variant={'secondary'}
        />
      </footer>
    </main>
  );
};

export default ScreenSellMode;
